import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var TwitterIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 26 26" }),
    React.createElement("path", { d: "M23 6.8c-.8.4-1.5.5-2.4.6.9-.5 1.5-1.2 1.8-2.2-.8.5-1.6.8-2.6 1-.8-.8-1.9-1.2-3-1.2-2.1 0-4 1.9-4 4.1 0 .4 0 .6.1.9-3.4-.2-6.5-1.9-8.5-4.4-.4.7-.5 1.3-.5 2.2 0 1.4.8 2.6 1.9 3.4-.6 0-1.2-.2-1.9-.5 0 2 1.4 3.6 3.3 4-.4.1-.8.1-1.1.1-.2 0-.5 0-.8-.1.5 1.6 2 2.9 3.9 2.9-1.4 1-3.2 1.6-5.2 1.6H3c1.9 1.1 4 1.9 6.2 1.9 7.5 0 11.6-6.3 11.6-11.6V9c1-.6 1.7-1.4 2.2-2.2z" }))); };

export { TwitterIcon as default };
